import { isPlatform } from './ionic-platform';

export type Platform = 'ios' | 'android' | 'web';

export function getPlatform(): Platform {
  if (isPlatform('capacitor')) {
    if (isPlatform('ios')) {
      return 'ios';
    }
    if (isPlatform('android')) {
      return 'android';
    }
  }
  return 'web';
}

export const isCapacitor = () => isPlatform('capacitor');
export const isIOS = () => isPlatform('ios');
export const isAndroid = () => isPlatform('android');
